// extracted by mini-css-extract-plugin
export default {"container":"Welcome_container__bfXAO","heading":"Welcome_heading__B1OEW","button":"Welcome_button__5R8U9"};